import { api } from "../utils/api";
import type {
  RestCreateModifier,
  RestModifier,
  RestUpdateModifier,
} from "@KassaroAB/shared/types/modifier";
import type { ModifierId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const modifiersPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "modifiers");

export const getModifiersApi = (
  scope: CatalogScope,
): Promise<RestModifier[]> => {
  return api.get(modifiersPath(scope));
};

export const getModifierApi = (
  scope: CatalogScope,
  modifierId: ModifierId,
): Promise<RestModifier> => {
  return api.get(`${modifiersPath(scope)}/${modifierId}`);
};

export const createModifierApi = (
  scope: CatalogScope,
  modifier: RestCreateModifier,
): Promise<RestModifier> => {
  return api.post(modifiersPath(scope), modifier);
};

export const updateModifierApi = (
  scope: CatalogScope,
  modifierId: ModifierId,
  modifier: RestUpdateModifier,
): Promise<RestModifier> => {
  return api.put(`${modifiersPath(scope)}/${modifierId}`, modifier);
};

export const deleteModifierApi = (
  scope: CatalogScope,
  modifierId: ModifierId,
): Promise<void> => {
  return api.delete(`${modifiersPath(scope)}/${modifierId}`);
};
